import { Box, Button, CircularProgress } from '@mui/material';
import { useThemeColors } from '../../hooks/useThemeColors';

interface Props {
  formikProps: any;
  isLoading: boolean;
  isEditing: boolean;
  onCancel: () => void;
}

const CustomButtons = ({
  formikProps,
  isLoading,
  isEditing,
  onCancel,
}: Props) => {
  const { warning } = useThemeColors();

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        type="submit"
        variant="contained"
        sx={{
          textTransform: 'none',
          fontSize: 14,
          px: 3,
          py: 1,
          backgroundColor: 'rgb(76, 10, 39)',
          '&:hover': {
            backgroundColor: 'rgb(76, 10, 39, 0.8)',
          },
          '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            color: 'rgba(0, 0, 0, 0.26)',
          },
        }}
        onClick={() => formikProps.handleSubmit()}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <CircularProgress size={16} sx={{ color: '#fff', mr: 1 }} />
            {isEditing ? 'Updating...' : 'Creating...'}
          </>
        ) : isEditing ? (
          'Update'
        ) : (
          'Create'
        )}
      </Button>

      {!isEditing && (
        <Button
          type="button"
          variant="outlined"
          onClick={() => {
            formikProps.resetForm();
            const fileInput = document.getElementById(
              'image-upload-input'
            ) as HTMLInputElement;
            if (fileInput) fileInput.value = '';
          }}
          sx={{
            textTransform: 'none',
            fontSize: 14,
            px: 3,
            py: 1,
            borderColor: '#666',
            color: '#666',
            '&:hover': {
              borderColor: '#333',
              color: '#333',
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            '&:disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
              color: 'rgba(0, 0, 0, 0.26)',
            },
          }}
        >
          Reset
        </Button>
      )}

      <Button
        type="button"
        variant="outlined"
        color="error"
        onClick={onCancel}
        sx={{
          bgcolor: warning.main,
          color: '#fff',
          '&:hover': {
            bgcolor: warning.dark,
            color: '#fff',
          },
        }}
      >
        Cancel
      </Button>
    </Box>
  );
};

export default CustomButtons;
